export default __webpack_public_path__ + "static/media/bg-1.5eae2aa9.jpg";